export function isMobileDevice() {
  // 1. Touch support
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 2. Screen size
  const isMobileScreen = window.innerWidth <= 768;

  const isMobile =
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (isTouchDevice && isMobileScreen);

  return isMobile;
}
